<template lang="pug">
#projects
  section.section.page-section.container.is-fluid
    spinner(v-if="settings.loading")
    .blocks(v-else)
</template>

<script>
export default {
  name: 'projects',
  created() {

  },
  data() {
    return {
      settings: {
        loading: false,
      },
    };
  },
};
</script>

<style lang="scss">
#projects {
  @include blocks;
}
</style>
